import { FilterCollection, FilterValueCollection } from "@hub/generated/models";

export class FilterHelpers {
  public static addOrUpdateFilter(filterCollection: FilterCollection, value: FilterValueCollection) {
    if (!filterCollection)
      filterCollection = new FilterCollection();

    if (!filterCollection.List)
      filterCollection.List = [value];
    else {
      let collection: FilterValueCollection = filterCollection.List.find(
        item => item.ColumnName == value.ColumnName
      );
      if (!collection)
        filterCollection.List.push(value);
      else if (!value.List) {
        collection.ColumnName = "";
      } else
        collection.List = value.List;
    }

    return filterCollection;
  }
}
